import { logPhysicalDrFailure, PRINT_PHYSICAL_DR_FAILED_MESSAGE } from "./physicalDrLogging";
import { printPdfBlobUrl } from "./printPdfBlobUrl";
import { getPhysicalDrBlobUrl } from "./getPhysicalDrBlobUrl";
import { PHYSICAL_DR_CONTENT } from "../content";

export interface TriggerPhysicalDrPrintOptions {
  terminalCode: string;
  routeIds: string[];
  onFailure?: () => void;
  onComplete?: () => void;
}

export async function triggerPhysicalDrPrint(
  options: TriggerPhysicalDrPrintOptions
): Promise<void> {
  const { terminalCode, routeIds, onFailure, onComplete } = options;

  if (!terminalCode || !routeIds?.length) {
    onComplete?.();
    return;
  }

  try {
    const blobUrl = await getPhysicalDrBlobUrl({
      terminalCode,
      routeIds,
    });

    onComplete?.();

    printPdfBlobUrl(blobUrl, () => {
      URL.revokeObjectURL(blobUrl);
    });
  } catch (error: any) {
    if (error?.message !== PRINT_PHYSICAL_DR_FAILED_MESSAGE) {
      logPhysicalDrFailure(PHYSICAL_DR_CONTENT.logging.printPipelineFailed, error);
    }
    onComplete?.();
    onFailure?.();
  }
}
